import { useNavigate } from "react-router";
import { url } from "../../../../utils/url";
//import logoMainSvg from "../../../../assets/icons/logo-text.svg";
import { Img, Root, RootMobile, Text } from "./styles";
import { ReactComponent as LogoMainSvg } from "../../../../assets/icons/logo-text.svg";
import Icon from "../../../../components/icon";

const webName = ``;

interface LogoMainProps {
  isLoged: boolean;
  isNerrowPage: boolean;
}

export const LogoMain = ({ isLoged, isNerrowPage }: LogoMainProps) => {
  let navigate = useNavigate();
  return (
    <>
      <Root onClick={() => navigate(url.homePage)} isLoged={isLoged}>
        <RootMobile style={{ marginLeft: isNerrowPage ? 0 : 0 }}>
        <Icon width="100%" height="100%" icon={<LogoMainSvg />} />
          {/* <Text>{webName}</Text> */}
        </RootMobile>
      </Root>
    </>
  );
};
